import { render, staticRenderFns } from "./SmTableRepairPlanDetail.vue?vue&type=template&id=197d35e2&scoped=true&"
import script from "./SmTableRepairPlanDetail.vue?vue&type=script&lang=ts&"
export * from "./SmTableRepairPlanDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SmTableRepairPlanDetail.vue?vue&type=style&index=0&id=197d35e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197d35e2",
  null
  
)

export default component.exports